"use client";

import { useEffect } from "react";
import Image from "next/image";
import styles from "./TopSearchModal.module.scss";
import { usePathname, useRouter } from "next/navigation";
import Button from "@components/atoms/Button";
import assetLoader from "@utils/internalImageLoder";
import { useGlobalLoader } from "@hooks/useGlobalLoader";
import { getPageNameFromUrl } from "@utils/pageNameUtils";

function TopSearchModal({cityName}: any) {
  const router = useRouter();
  const pathname = usePathname();
  const { showLoader, hideLoader } = useGlobalLoader();

  useEffect(() => {
    hideLoader();
  }, [pathname, hideLoader]);

  return (
    <>
      <Button
        className={styles.searchTriggerButton}
        onButtonClick={() => {
          showLoader();
          router.push("/search");
        }}
        segmentEventProps={{
          eventName: "action",
          eventProperties: {
            action_type: "tap_btn",
            action_name: "tap_btn_search",
            city_name: cityName,
          },
          pageType: getPageNameFromUrl(pathname),
        }}
      >
        <Image
          src={`${assetLoader()}/icons/search_light.svg`}
          alt="search icon"
          width={20}
          height={20}
        />
      </Button>
    </>
  );
}

export default TopSearchModal;
